<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-10 18:10 -->
<!-- Description:  -->
<template>
  <div>
    <table class="table table-bordered mb-3">
      <slot :list="list"></slot>
    </table>

    <div class="alert alert-secondary mb-3" v-show="loading">
      Cargando ...
    </div>

    <div class="alert alert-danger mb-3" v-show="hasError">
      No se logro cargar la lista por un error.
    </div>

    <PaginateSimple :pagination="paginateData"
      @change="paginateData.page=$event;reload();"
    ></PaginateSimple>
  </div>
</template>
<script>
import PaginateSimple from "./paginate-simple.vue";
// script content
export default {
  name: "ApirestTable",
  components: {
    PaginateSimple
  },

  // directives

  props: {
    getList: {
      required: true,
    },
    params: {
      default: () => ({}),
    },
    loadAfterMount: {
      default: true,
    }
  },

  data: () => ({
    list: [],
    paginateData: {},
    loading: false,
    hasError: false,
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    if(this.loadAfterMount) {
      this.reload();
    }
  },

  methods: {
    async reload() {
      try {
        this.hasError = false;
        this.loading = true;
        this.list = [];
        let res = await this.getList({
          ...this.params,
          page: this.paginateData.page,
          per_page: this.paginateData.per_page,
        });
        this.list = res.data;
        this.paginateData = res;
        this.loading = false;
      } catch (e) {
        this.hasError = true;
      }
    }
    //
    //
  }
};
</script>
<style scoped></style>

